import type { LucideIcon } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import type { RoleAccent } from "@/features/team/utils/format";

export interface KpiCardProps {
	icon: LucideIcon;
	accent: RoleAccent;
	label: string;
	value: string;
	sub?: string;
}

export function KpiCard({
	icon: Icon,
	accent,
	label,
	value,
	sub,
}: KpiCardProps) {
	return (
		<Card className="kpi-card">
			<CardContent className="kpi-card__content">
				<div className="kpi-card__row">
					<div className="kpi-card__text">
						<div className="kpi-card__label">{label}</div>
						<div className="kpi-card__value">{value}</div>
					</div>
					<span
						className="team-accent-tile"
						data-accent={accent}
						data-size="lg"
					>
						<Icon />
					</span>
				</div>
				{sub && <div className="kpi-card__sub">{sub}</div>}
			</CardContent>
		</Card>
	);
}
